import { useQuery } from "@tanstack/react-query";
import { CacheKey } from "../models/cacheKey";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import { TicketCheckInStatus } from "../models/enum/ticketCheckInStatus";
import {
  WinnerCheckInStatus,
  WinnerCheckInStatusListWrapperDto,
} from "../models/winnerCheckInStatus";
import { Response } from "../models/response";

export function useCheckInUsers({
  artistId,
  eventId,
  rewardId,
  status,
}: {
  artistId?: number;
  eventId?: number;
  rewardId?: number;
  status: TicketCheckInStatus;
}) {
  const {
    data: checkInUsers,
    refetch,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [CacheKey.getCheckInUsers, eventId, rewardId, status],
    queryFn: async () => {
      if (artistId && eventId && rewardId) {
        const response = new Response<WinnerCheckInStatusListWrapperDto>(
          await HttpClient.request(
            OnSiteApi.fansByTicketCheckInStatus(
              artistId,
              eventId,
              rewardId,
              status,
            ),
          ),
        );
        return WinnerCheckInStatus.winnerCheckInStatusList(response.data);
      } else {
        return null;
      }
    },
  });

  return { checkInUsers, refetch, isLoading, isError, error };
}
